module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundL.f08224d.woff";